// Shared status metadata and date helpers for every appointment view.

export const APPOINTMENT_STATUS = {
  scheduled: {
    label: "Agendada",
    dot: "bg-slate-400",
    badge:
      "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300 border-slate-200 dark:border-slate-700",
  },
  confirmed: {
    label: "Confirmada",
    dot: "bg-emerald-500",
    badge:
      "bg-emerald-50 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-300 border-emerald-200 dark:border-emerald-800",
  },
  cancelled: {
    label: "Cancelada",
    dot: "bg-red-500",
    badge:
      "bg-red-50 text-red-700 dark:bg-red-950/40 dark:text-red-300 border-red-200 dark:border-red-800",
  },
  completed: {
    label: "Asistió",
    dot: "bg-indigo-500",
    badge:
      "bg-indigo-50 text-indigo-700 dark:bg-indigo-950/40 dark:text-indigo-300 border-indigo-200 dark:border-indigo-800",
  },
  no_show: {
    label: "No asistió",
    dot: "bg-amber-500",
    badge:
      "bg-amber-50 text-amber-700 dark:bg-amber-950/40 dark:text-amber-300 border-amber-200 dark:border-amber-800",
  },
};

export const statusMeta = (status) =>
  APPOINTMENT_STATUS[status] || APPOINTMENT_STATUS.scheduled;

export const DEFAULT_REASON_COLOR = "#6366f1";

/** Date -> "YYYY-MM-DDTHH:mm" for <input type="datetime-local"> (browser local). */
export const toDatetimeLocal = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

/** Combine a Date (day) and an hour into a datetime-local string. */
export const dayAtHour = (day, hour = 9) => {
  const date = new Date(day);
  date.setHours(hour, 0, 0, 0);
  return toDatetimeLocal(date);
};
